import { render, staticRenderFns } from "./IntakeWizard.vue?vue&type=template&id=3cdfeace&scoped=true"
import script from "./IntakeWizard.vue?vue&type=script&lang=js"
export * from "./IntakeWizard.vue?vue&type=script&lang=js"
import style0 from "./IntakeWizard.vue?vue&type=style&index=0&id=3cdfeace&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdfeace",
  null
  
)

export default component.exports